import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { RoutingUtilsService } from '../../services/routing-utils.service';
import {MatDialog} from "@angular/material/dialog";
import {IomModuleService} from "../../services/iom-module.service";
import { Router} from "@angular/router";
import { ClearIomDialogComponent } from '../clear-iom-dialog/clear-iom-dialog.component';
import { NavigationDialogComponent } from '../navigation-dialog/navigation-dialog.component';
import { SupportCardComponent } from '../support-card/support-card.component';
import { AuthService } from '@rsmu/auth';
import { Subject, take } from 'rxjs';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss'],
    standalone: true,
    imports: [MatIconModule, NgIf]
})
export class SideNavComponent implements OnDestroy {
  parentLink: string = '';
  private destroy$ = new Subject<void>();

  @Output() closeMenu = new EventEmitter<void>();

  constructor(
    private readonly dialog: MatDialog,
    private readonly iom: IomModuleService,
    private readonly router: Router,
    private readonly auth: AuthService,
    private readonly routingUtils: RoutingUtilsService
  ) {

    }

  get moduleId(): string | undefined {
    return this.routingUtils.moduleId;
  };

  get showResetBtn():  boolean | undefined {
    return this.iom.showResetBtn;
  }

  logout() {
    this.auth.logout$()
    .pipe(take(1))
    .subscribe();
  }

  goHome() {
    this.router.navigate(['/', this.moduleId]).then(() => {
      this.closeMenu.emit();
    })
  }

  handleCatClick() {
    this.dialog.open(ClearIomDialogComponent, {
      data: {
        iomId: this.moduleId
      }
    })
  }

  handleChatClick() {
  }

  // мобилка текст содержание во всплывающем меню справа
  handleNavigationClick() {
    this.dialog.open(NavigationDialogComponent, {
      maxWidth: '33rem',
      maxHeight: '85vh',
      data: {
        iomTitle: this.iom.title,
        iomType: this.iom.type,
        iomId: this.moduleId}
    })
    this.closeMenu.emit();
  }

  handleQuestionClick() {
    this.dialog.open(SupportCardComponent, {
      minHeight: '15rem',
      maxWidth: '85vw',
      maxHeight: '85vh'
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
